export default __webpack_public_path__ + "static/media/medal-silver.4589dc31.svg";